import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getBrowserStorageSupport } from "../helper/browserStorage";
import "./EssentialStorageAlert.css";

const EssentialStorageAlert = () => {
  const [blocked, setBlocked] = useState(false);

  useEffect(() => {
    const support = getBrowserStorageSupport();
    setBlocked(!(support.cookies && support.localStorage && support.sessionStorage));
  }, []);

  if (!blocked) {
    return null;
  }

  return (
    <div className="essential-storage-alert" role="alert">
      <strong>Essential cookies and browser storage are required.</strong>
      <span>
        FamilySafe needs essential cookies and browser storage to keep you signed in, protect your
        account, handle billing redirects, and operate your secure vault. These are not used for
        advertising or optional tracking. Please allow essential cookies and storage for FamilySafe to
        continue.
      </span>
      <Link to="/essential-storage" className="essential-storage-alert-link">
        Why FamilySafe needs this
      </Link>
    </div>
  );
};

export default EssentialStorageAlert;
